import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hr from './locales/hr/common.json';
import en from './locales/en/common.json';
import de from './locales/de/common.json';

i18n
    .use(initReactI18next)
    .init({
        lng: localStorage.getItem('lang') || 'hr',
        fallbackLng: 'hr',
        debug: false,
        resources: {
            hr: { common: hr },
            en: { common: en },
            de: { common: de },
        },
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        }
    });

export default i18n;
